import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAnalysisDashboardState } from '@shared/models';
import * as Response from '@shared/models/analysis/analysis.response.type';
import { fetchWeeklyPointsHistory, fetchWeeklyTimeSpent } from '../queries';

const state: IAnalysisDashboardState = {
    weeklyPoints: {
        currentWeekPointsByType: {
            competition: 0,
            event: 0,
            challenge: 0,
            module: 0,
        },
        differences: {
            competition: 0,
            event: 0,
            challenge: 0,
            module: 0,
        },
        challenge: {
            overall: 0,
            taken: 0,
        },
        hasNoPointsHistory: false,
    },
    fetchingWeeklyPoints: false,
    weeklyTimeSpent: {
        weekly: null,
        average: {
            averageUsersDurationInSeconds: 0,
            averageSchoolDurationInSeconds: 0,
            averageGlobalDurationInSeconds: 0,
        },
        sum: {
            sumOfUsersDurationInSeconds: 0,
            countOfUsersDurationInSeconds: 0,
            sumOfSchoolDurationInSeconds: 0,
            countOfSchoolDurationInSeconds: 0,
            sumOfGlobalDurationInSeconds: 0,
            countOfGlobalDurationInSeconds: 0,
        },
    },
    fetchingWeeklyTimeSpent: false,
};

const anaylsisDashboardSlice = createSlice({
    name: 'analysis-dashboard',
    initialState: state,
    reducers: {
        setWeeklyPointsHistory: (state, { payload }: PayloadAction<Response.IWeeklyPointsHistoryResponse>) => {
            state.weeklyPoints = {
                currentWeekPointsByType: {
                    competition: payload.currentWeekPointsByType?.competition || 0,
                    event: payload.currentWeekPointsByType?.event || 0,
                    challenge: payload.currentWeekPointsByType?.challenge || 0,
                    module: payload.currentWeekPointsByType?.module || 0,
                },
                differences: {
                    competition: payload.differences?.competition || 0,
                    event: payload.differences?.event || 0,
                    challenge: payload.differences?.challenge || 0,
                    module: payload.differences?.module || 0,
                },
                challenge: {
                    overall: payload.challenge?.overall || 0,
                    taken: payload.challenge?.taken || 0,
                },
                hasNoPointsHistory: payload.hasNoPointsHistory || false,
            };
        },
        setWeeklyTimeSpent: (state, { payload }: PayloadAction<Response.IWeeklyTimeSpentResponse>) => {
            state.weeklyTimeSpent = {
                weekly: payload.weekly,
                average: {
                    averageGlobalDurationInSeconds: payload.average?.averageGlobalDurationInSeconds || 0,
                    averageUsersDurationInSeconds: payload.average?.averageUsersDurationInSeconds || 0,
                    averageSchoolDurationInSeconds: payload.average?.averageSchoolDurationInSeconds || 0,
                },
                sum: {
                    sumOfUsersDurationInSeconds: payload.sum?.sumOfUsersDurationInSeconds || 0,
                    countOfUsersDurationInSeconds: payload.sum?.countOfUsersDurationInSeconds || 0,
                    sumOfSchoolDurationInSeconds: payload.sum?.sumOfSchoolDurationInSeconds || 0,
                    countOfSchoolDurationInSeconds: payload.sum?.countOfSchoolDurationInSeconds || 0,
                    sumOfGlobalDurationInSeconds: payload.sum?.sumOfGlobalDurationInSeconds || 0,
                    countOfGlobalDurationInSeconds: payload.sum?.countOfGlobalDurationInSeconds || 0,
                },
            };
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchWeeklyPointsHistory.pending, (state) => {
            state.fetchingWeeklyPoints = true;
        });
        builder.addCase(fetchWeeklyPointsHistory.rejected, (state) => {
            state.fetchingWeeklyPoints = false;
        });
        builder.addCase(fetchWeeklyPointsHistory.fulfilled, (state) => {
            state.fetchingWeeklyPoints = false;
        });
        builder.addCase(fetchWeeklyTimeSpent.pending, (state) => {
            state.fetchingWeeklyTimeSpent = true;
        });
        builder.addCase(fetchWeeklyTimeSpent.rejected, (state) => {
            state.fetchingWeeklyTimeSpent = false;
        });
        builder.addCase(fetchWeeklyTimeSpent.fulfilled, (state) => {
            state.fetchingWeeklyTimeSpent = false;
        });
    },
});

export const { setWeeklyPointsHistory, setWeeklyTimeSpent } = anaylsisDashboardSlice.actions;
export default anaylsisDashboardSlice.reducer;
